module.exports = __webpack_public_path__ + "img/photo-0106.3788e62e.jpg";